// extracted by mini-css-extract-plugin
export default {"image":"OuR0b"};